export const CONSENT_LEVELS_WITHOUT_NONE = [
  "necessary",
  "analytics",
  "marketing",
  "retargeting",
  "tracking",
] as const;
